import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Box,
  IconButton,
} from "@mui/material";
import { Warning as WarningIcon } from "@mui/icons-material";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import authActions from "../../redux/reducers/auth/actions";
import useStyles from "./styles";

const SecurityPolicyModal = ({ open, onConfirm }) => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const navigate = useNavigate();

  // Log when modal opens/closes
  React.useEffect(() => {
    if (open) {
      // console.log("🚨 [MODAL] Security Policy Modal OPENED");
      // console.log("🚨 [MODAL] User will be forced to re-login");
    } else {
      // console.log("🔒 [MODAL] Security Policy Modal CLOSED");
    }
  }, [open]);

  const handleConfirm = () => {
    // Clear all auth data
    dispatch(authActions.clearAllData());

    // Navigate to login page
    navigate("/login");

    // Call the onConfirm callback if provided
    if (onConfirm) {
      // console.log("🔒 [MODAL] Calling onConfirm callback");
      onConfirm();
    }
  };

  return (
    <Dialog
      open={open}
      maxWidth="sm"
      fullWidth
      disableEscapeKeyDown
      disableBackdropClick
      onBackdropClick={(e) => e.preventDefault()}
      onEscapeKeyDown={(e) => e.preventDefault()}
      classes={{
        paper: classes.modalPaper,
      }}
    >
      <DialogTitle className={classes.modalTitle}>
        <Box display="flex" alignItems="center" gap={1}>
          <WarningIcon className={classes.warningIcon} />
          <Typography
            variant="h6"
            component="span"
            color="red"
            letterSpacing={0}
          >
            Security Policy Update
          </Typography>
        </Box>
      </DialogTitle>

      <DialogContent className={classes.modalContent}>
        <Typography variant="body1" className={classes.message}>
          Our security policies have changed recently. For your account's
          safety, please re-login to continue using the application.
        </Typography>

        <Typography variant="body2" className={classes.note}>
          This action will log you out and redirect you to the login page.
        </Typography>
      </DialogContent>

      <DialogActions className={classes.modalActions}>
        <Button
          variant="contained"
          color="primary"
          onClick={handleConfirm}
          className={classes.confirmButton}
          sx={{ marginBottom: "2vh" }}
        >
          Confirm & Re-login
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default SecurityPolicyModal;
